module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-purple-ca30ee9f1657530811a56d88688126e9.svg";